module.exports = __webpack_public_path__ + "img/chord-up.6795db36.png";